import React, { forwardRef } from "react";

/**
 * Card
 * - Simple card wrapper used for grouping content
 * - Accepts className for custom styling
 * - Supports ref forwarding
 *
 * Usage:
 *  <Card className="p-4">...</Card>
 */

const Card = forwardRef(({ children, className = "", ...props }, ref) => {
  // If className includes p-0, don't add default padding
  const hasCustomPadding = className.includes("p-0") || className.includes("p-");
  const defaultPadding = hasCustomPadding ? "" : "p-4";
  
  return (
    <div ref={ref} className={`bg-white rounded shadow ${defaultPadding} ${className}`} {...props}>{children}</div>
  );
});

Card.displayName = "Card";

export default Card;
